import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IProcess } from '@obvious.tech/constellation'

export const Process = defineEntity('Process', {
  endpoint: 'flow/api/Process',
  schema: SNoop<IProcess>(),
})
